import React from 'react';
import { IconProps } from '.';

const SvgVvip = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        d='M7.928 14.603 7.119 12H6l1.35 4h1.154l1.268-3.77L11.045 16h1.153l1.345-4h-1.108l-.813 2.603L10.813 12H8.741l-.813 2.603ZM13.646 16h1.012v-4h-1.011v4Z'
      />
      <path
        fill={color}
        fillRule='evenodd'
        d='M15.014 12h1.556c.44 0 .8.14 1.05.391.251.252.38.603.38 1 0 .403-.131.754-.386 1.005-.254.25-.62.386-1.065.386h-.524V16h-1.011v-4Zm1.826 1.036c-.08-.08-.21-.136-.412-.137h-.403v.995h.404c.2 0 .33-.058.41-.138.08-.081.126-.202.125-.364v-.002c0-.159-.045-.276-.124-.354Z'
        clipRule='evenodd'
      />
      <path
        fill={color}
        fillRule='evenodd'
        d='M6.25 1.25h11.5V7h-.093A9 9 0 1 1 6.342 7H6.25V1.25Zm10 1.5v3.315a8.943 8.943 0 0 0-3.5-1.034V2.75h3.5Zm-8.5 0h3.5v2.28a8.943 8.943 0 0 0-3.5 1.035V2.75ZM19.5 14a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgVvip;
